/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Manage_FiltersInputs */

const en_common_manage_filters = /** @type {(inputs: Common_Manage_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Filters`)
};

/**
* | output |
* | --- |
* | "Manage Filters" |
*
* @param {Common_Manage_FiltersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const common_manage_filters = /** @type {((inputs?: Common_Manage_FiltersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Manage_FiltersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_manage_filters(inputs)
});